export default __webpack_public_path__ + "static/media/contract.6cc2102e.png";